import { Check } from "lucide-react";
import { CTAButton, MaskedLines, Reveal, SectionTag } from "../components/ui-bits";
import { CHAPTERS } from "../content";

export default function HowItWorks() {
    return (
        <div data-testid="how-it-works-page">
            <section className="blueprint-grid border-b border-inkline">
                <div className="mx-auto max-w-[1440px] px-6 pb-16 pt-16 md:px-10 lg:pb-24 lg:pt-24">
                    <SectionTag>How it works</SectionTag>
                    <MaskedLines
                        lines={["FIVE CHAPTERS.", "ONE COMPLIANT", "BUILDING."]}
                        className="font-display text-[13vw] font-bold leading-[0.9] tracking-tighter sm:text-7xl lg:text-[6rem]"
                        accentIndexes={[1]}
                    />
                    <Reveal delay={0.6}>
                        <p className="mt-8 max-w-xl text-base leading-relaxed text-smoke md:text-lg">
                            From first walkthrough to final sign-off, every step is documented against the 2010 ADA
                            Standards and CBC Chapter 11B. You always know what's next — and what it costs.
                        </p>
                    </Reveal>
                </div>
            </section>

            <section data-testid="chapters-list" className="border-b border-inkline">
                <div className="mx-auto max-w-[1440px] px-6 md:px-10">
                    {CHAPTERS.map((c, i) => (
                        <Reveal key={c.n}>
                            <div
                                data-testid={`chapter-${c.n}`}
                                className={`grid grid-cols-1 gap-8 py-16 md:py-20 lg:grid-cols-12 ${i !== 0 ? "border-t border-inkline" : ""}`}
                            >
                                <div className="lg:col-span-4">
                                    <div className="lg:sticky lg:top-28">
                                        <p className="font-display text-7xl font-bold tracking-tighter text-bluebrand md:text-8xl">
                                            {c.n}
                                        </p>
                                        <p className="mt-4 inline-block border border-inkline px-3 py-1 text-[11px] font-bold uppercase tracking-widest text-smoke">
                                            {c.time}
                                        </p>
                                    </div>
                                </div>
                                <div className="lg:col-span-8">
                                    <h2 className="font-display text-3xl font-bold tracking-tight md:text-5xl">{c.title}</h2>
                                    <p className="mt-6 max-w-2xl text-base leading-relaxed text-smoke md:text-lg">{c.desc}</p>
                                    <ul className="mt-8 grid max-w-2xl grid-cols-1 gap-3 sm:grid-cols-2">
                                        {c.points.map((p) => (
                                            <li key={p} className="flex items-start gap-3 border border-inkline bg-paper p-4">
                                                <span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center bg-volt">
                                                    <Check className="h-3.5 w-3.5 text-ink" strokeWidth={3} />
                                                </span>
                                                <span className="text-sm font-semibold">{p}</span>
                                            </li>
                                        ))}
                                    </ul>
                                </div>
                            </div>
                        </Reveal>
                    ))}
                </div>
            </section>

            <section className="bg-volt">
                <div className="mx-auto flex max-w-[1440px] flex-col items-start justify-between gap-8 px-6 py-20 md:flex-row md:items-center md:px-10">
                    <Reveal>
                        <h2 className="font-display text-4xl font-bold leading-none tracking-tight text-ink md:text-6xl">
                            Start at chapter one.
                        </h2>
                        <p className="mt-4 max-w-md text-sm font-semibold text-ink/70 md:text-base">
                            Book a free site walk. We'll bring the tape measure, the codebooks, and a 48-hour quote.
                        </p>
                    </Reveal>
                    <Reveal delay={0.1}>
                        <CTAButton to="/get-started" variant="ink" testid="hiw-cta-start">
                            Book your site walk
                        </CTAButton>
                    </Reveal>
                </div>
            </section>
        </div>
    );
}
